import {Input} from '@mantine/core';
import {Space} from 'src/design/atoms/Space';
import React, {useCallback} from 'react';
import {VideoSelectBox} from 'src/app/databound-elements/VideoSelectBox';
import type {ISelectOption} from 'src/types/Form';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormVideoSelectorProps {
  field: IFormFieldV2;
  value: string | number;
  error?: string;
  onChange: (name: string, value: any, displayValue?: string) => void;
}

export const FormVideoSelector = React.memo<FormVideoSelectorProps>(
  ({field, value, error, onChange}: FormVideoSelectorProps) => {
    const handleVideoChange = useCallback(
      (value: ISelectOption | null): void => {
        onChange(field.name, value?.id, value?.text ?? value?.label);
      },
      [field.name, onChange]
    );

    return (
      <Input.Wrapper
        data-testid={`form-field-${field.name}`}
        label={field.label}
        withAsterisk={field.required}
        error={error}
        description={field.description}>
        <Space mb="xs" />
        <VideoSelectBox
          onSelectChangeCallback={handleVideoChange}
          label={''}
          value={String(value)}
          error={!!error}
          disabled={field.disabled}
          queryOptions={{}}
        />
      </Input.Wrapper>
    );
  }
);
